import React, { useEffect } from 'react';
import { useAvatarContext } from './context';
import { ImageLayer } from './view';

interface Props {
    src: string;
    alt?: string;
}

export const AvatarImage = ({ src, alt }: Props) => {
    const { setStatus } = useAvatarContext('Avatar.Image');

    // Картинка рисуется фоном (ImageLayer) — красится из кэша синхронно, без мигания.
    // Detached-загрузка лишь скрывает заглушку после готовности / оставляет при ошибке.
    useEffect(() => {
        let isMounted = true;
        const image = new Image();
        image.onload = () => {
            if (isMounted) setStatus('loaded');
        };
        image.onerror = () => {
            if (isMounted) setStatus('error');
        };
        image.src = src;

        return () => {
            isMounted = false;
            setStatus('idle');
        };
    }, [src, setStatus]);

    // alt задан — объявляем картинкой с именем; иначе фон декоративен (имя несёт текст рядом).
    const a11yProps = alt
        ? {
              role: 'img',
              'aria-label': alt,
          }
        : undefined;

    return (
        <ImageLayer
            {...a11yProps}
            style={{
                backgroundImage: `url("${src}")`,
            }}
        />
    );
};
